module.exports = __webpack_public_path__ + "img/selected6-min.4093f81c.png";